<template>
  <v-form ref="consultForm" v-model="formValidity" id="the-form">
    <v-container v-if="!done" style="max-width:600px">
      <h3 v-if="!in_iframe" class="pb-2">Request a Booking Consultation</h3>
      <h4 v-if="brandName && !in_iframe" class="pb-2">
        <v-avatar v-if="brandLogo">
          <v-img :src="brandLogo"></v-img>
        </v-avatar>
        {{ brandName }}
      </h4>
      <h4 v-if="artistName" class="pb-2">Artist: {{ artistName }}</h4>
      <v-row>
        <v-col class="mx-0 py-0 primary--text"><h4>First name</h4></v-col>
        <v-col class="mx-0 py-0 primary--text"><h4>Last name</h4></v-col>
      </v-row>
      <v-row>
        <v-col cols=6 class="py-0">
          <v-text-field
            v-model.trim="first"
            type="text"
            :rules="firstRules"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col class="py-0">
          <v-text-field
            v-model.trim="last"
            type="text"
            :rules="lastRules"
            outlined
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="mx-0 py-0 primary--text"><h4>Email</h4></v-col>
      </v-row>
      <v-row>
        <v-col class="py-0">
          <v-text-field
            xlabel="Email"
            type="email"
            v-model.trim="email"
            :rules="emailRules"
            :error-messages="emailErrors"
            outlined
            dense
            name="email"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <!-- <v-col class="mx-0 py-0 primary--text"><h4>ZIP code</h4></v-col> -->
        <v-col class="mx-0 py-0 primary--text"><h4>Cell phone</h4></v-col>
      </v-row>
      <v-row>
        <!-- <v-col cols="6" class="py-0">
          <v-text-field
            v-model.trim="zipcode"
            type="text"
            :rules="zipcodeRules"
            :validate-on-blur="true"
            color="primary"
            inputmode="numeric"
            :error-messages="zipcodeErrors"
            outlined
            dense
            name="zipcode"
          ></v-text-field>
        </v-col> -->
        <v-col class="py-0" md="6">
          <v-text-field
            v-model.trim="cell"
            type="text"
            :rules="cellRules"
            color="primary"
            inputmode="numeric"
            @blur="formatCell"
            :persistent-hint="true"
            hint="The number we will use to call and text you"
            outlined
            dense
            name="cell"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="mx-0 py-0 primary--text"><h4>Please select the type of booking</h4></v-col>
      </v-row>
      <v-row>
        <v-col class="py-0" md="6">
          <v-select v-model="eventType" :items="eventTypes" outlined dense :rules="eventTypeRules" @change="eventTypeChanged"></v-select>
        </v-col>
      </v-row>
      <v-row v-if="prepaid">
        <v-col class="mx-0 py-0 primary--text"><h4>Please tell us about your event</h4></v-col>
      </v-row>
      <v-row v-if="prepaid">
        <v-col class="py-0">
          <v-textarea v-model="description" type="text" rows="7" outlined dense xauto-grow :rules="descriptionRules"></v-textarea>
        </v-col>
      </v-row>
      <v-row v-if="prepaid">
        <v-col class="mx-0 py-0 primary--text"><h4>Start Date/Time <small>(required)</small></h4></v-col>
      </v-row>
      <v-row v-if="prepaid">
        <v-col class="py-0">
          <datetime
            v-model="start"
            type="datetime"
            input-id="start-datetime"
            :week-start="7"
            use12-hour
            :minute-step="5"
            placeholder="Click to choose"
            input-style="border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: #A9A9A9; width: 100%;"
          ></datetime>
        </v-col>
      </v-row>
      <v-row v-if="prepaid">
        <v-col class="mx-0 pt-4 pb-0 primary--text"><h4>End Date/Time <small>(required)</small></h4></v-col>
      </v-row>
      <v-row v-if="prepaid">
        <v-col class="py-0">
          <datetime
            v-model="end"
            type="datetime"
            input-id="end-datetime"
            :week-start="7"
            use12-hour
            :minute-step="5"
            placeholder="Click to choose"
            input-style="border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: #A9A9A9; width: 100%;"
          ></datetime>
        </v-col>
      </v-row>
      <v-row v-if="prepaid">
        <v-col class="mx-0 pb-0 primary--text"><h4>Please give us an idea of your budget for this event.</h4></v-col>
      </v-row>
      <v-row v-if="prepaid">
        <v-col cols=6 class="py-0" md="4">
          <v-text-field
            v-model="budget"
            type="decimal"
            outlined
            dense
            inputmode="decimal"
            :rules="budgetRules"
            @blur="validateBudget"
            @focus="selectText"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-btn color="primary" block large class="text-none f-rounded" :loading="loading" @click="checkForm">Continue</v-btn>
    </v-container>
    <v-container v-if="done" style="max-width:600px">
      <h3 class="pb-2">Request sent. Thanks! We'll be in touch soon.</h3>
      <!-- <h4 v-if="brandName" class="pb-2">{{ brandName }}</h4>
      <h4 v-if="artistName" class="pb-2">Artist: {{ artistName }}</h4>
      <v-row>
        <v-col class="mx-0 py-0 primary--text"><h4>First name</h4></v-col>
        <v-col class="mx-0 py-0 primary--text"><h4>Last name</h4></v-col>
      </v-row> -->
    </v-container>
    <v-dialog v-model="consultDlg" persistent :fullscreen="$vuetify.breakpoint.width < 501" max-width="390" overlay-opacity=.7>
      <!-- <v-card style="border-radius: 10px"> -->
      <v-card>
        <div class="text-center py-6 mb-0">
          <h2 class="b-header">Look OK?</h2>
        </div>
        <v-simple-table class="px-4 py-8 b-text">
          <template v-slot:default>
            <tbody>
              <tr>
                <td>Name</td>
                <td>{{first}} {{last}}</td>
              </tr>
              <tr>
                <td>Email</td>
                <td>{{email}}</td>
              </tr>
              <!-- <tr>
                <td>ZIP</td>
                <td>{{zipcode}}</td>
              </tr> -->
              <tr>
                <td>Cell phone</td>
                <td>{{cell}}</td>
              </tr>
              <tr>
                <td>Event type</td>
                <td>{{eventType}}</td>
              </tr>
              <tr v-if="prepaid">
                <td>Event description</td>
                <td class="bm-nl">{{ description }}</td>
              </tr>
              <tr v-if="prepaid">
                <td>Event start</td>
                <td>{{ showDate(start) }} {{ showTime(start) }}</td>
              </tr>
              <tr v-if="prepaid">
                <td>Event end</td>
                <td>{{ showDate(end) }} {{ showTime(end) }}</td>
              </tr>
              <tr v-if="prepaid">
                <td>Budget</td>
                <td>{{budget}}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-card-actions class="justify-center pb-6 px-4">
          <v-col cols=6><v-btn xdark block large color="white" style="10px" class="text-none" @click="consultDlg = false">Change</v-btn></v-col>
          <v-col cols=6><v-btn dark block large color="primary" style="10px" class="text-none" :loading="loading" @click="addConsult">Continue</v-btn></v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import axios from "axios";
import bmutils from '../bmutils.js'
export default {
  name: "consult",
  data: () => ({
    first: '',
    firstRules: [
      value => !!value || 'Required.',
    ],
    last: '',
    lastRules: [
      value => !!value || 'Required.',
    ],
    email: '',
    emailRules: [
      value => !!value || 'Required.',
      value => value.indexOf('@') !== 0 || 'Email should have a username.',
      value => value.includes('@') || 'Email should include an @ symbol.',
      // value =>
      //   value.indexOf('.') - value.indexOf('@') > 1 ||
      //   'Email should contain a valid domain.',
      value => value.includes('.') || 'Email should include a period symbol.',
      value =>
        value.indexOf('.') <= value.length - 3 ||
        'Email should contain a valid domain extension.'
    ],
    emailErrors: [],
    // zipcode: '',
    // zipcodeRules: [
    //   value => !!value || 'Required.',
    //   value => /^[0-9]{5}$/.test(value) || 'ZIP must be 5 digits'
    // ],
    // zipcodeErrors: [],
    // city: '',
    // state: '',
    cell: '',
    cellRules: [
      value => !!value || 'Required.',
    ],
    eventTypes: null,
    eventType: '',
    eventTypeRules: [
      value => !!value || 'Event type is required'
    ],
    paymentTiming: '',
    start: '',
    end: '',
    description: '',
    descriptionRules: [
      value => !!value || 'Please tell us about your event'
    ],
    budget: '0',
    budgetRules: [
      value => value > 0 || 'Please help us know your budget'
    ],
    artist_id: 0,
    agent_id: 1, // Daniel in production. Overridden by any ag query arg
    brand_id: 0,
    brandName: '',
    brandLogo: '',
    artistName: '',
    done: false,
    loading: false,
    consultDlg: false,
    formValidity: false
  }),
  mounted() {
    if(this.$store.state.login) {
      // can't consult if logged in
      //this.$router.push("home")
      this.$store.dispatch('logout')
    }
    if(this.$route.query.ag) {
      this.agent_id = this.$route.query.ag
    }
    if(this.$route.query.ar) {
      this.artist_id = this.$route.query.ar
      this.getArtist()
    }
    if(this.$route.query.b) {
      this.brand_id = this.$route.query.b
      this.getBrand()
    }
    this.getEventTypes()
  },
  computed: {
    in_iframe() {
      return window.self !== window.top; // in an iframe if they match
    },
    emailInvalidMsg: function() {
      return this.$store.state.emailInvalidMsg
    },
    prepaid: function() {
      return this.paymentTiming == 'prepaid'
    },
    gotDatetimes() {
      // datetime doesn't do Vuetify rules
      // alert(this.start && this.end)
      if(this.prepaid) {
        return this.start && this.end
      }
      return true
    },
  },
  watch: {
    email: function() {
      if(this.emailErrors.length > 0) {
        this.emailErrors = []
      }
    },
    // zipcode: function() {
    //   if(this.zipcodeErrors.length > 0) {
    //     this.zipcodeErrors = []
    //   }
    // },
  },
  methods: {
    eventTypeChanged() {
      this.paymentTiming = bmutils.paymentTiming(this.eventType)
    },
    formatCell() {
      this.cell = bmutils.formatCell(this.cell)
    },
    showDate(ts) {
      return bmutils.showDate(bmutils.isoToDatetime(ts))
    },
    showTime(ts) {
      return bmutils.showTime(bmutils.isoToDatetime(ts))
    },
    // showNotes(s) {
    //   return bmutils.nl2br(s)
    // },
    // resetForm() {
    //   this.$refs.consultForm.reset()
    // },
    // resetValidation() {
    //   this.$refs.consultForm.resetValidation()
    // },
    checkForm() {
      if(!this.$refs.consultForm.validate()) {
        this.$emit('error', "Please correct fields")
        return
      }
      if(!this.gotDatetimes) {
        this.$emit('error', "Event start or end time needed")
        return
      }
      this.consultDlg = true
      this.iFrameScrollToTop()
    },
    iFrameScrollToTop() {
      if(window.self !== window.top) { // in an iframe
        parent.postMessage("scrollToTop", "https://ivystonerecords.com")
      }
    },
    selectText(event) {
      event.target.select()
    },
    async getEventTypes() {
      this.$store.commit('SET_LOADING_STATUS', true);
      this.loading = true
      try {
        let result = await axios.get("event-types");
        // console.log(result);
        // this.eventTypes = [{text: 'No selection', value: 0}];
        this.eventTypes = [];
        result.data.forEach(el => {
          this.eventTypes.push(el)
        });
      } catch(err) {
        //console.log(err)
      }
      this.$store.commit('SET_LOADING_STATUS', false);
      this.loading = false
    },
    async getBrand() {
      this.$store.commit('SET_LOADING_STATUS', true);
      this.loading = true
      try {
        let result = await axios.get('brands' + '/' + this.brand_id);
        // console.log(result);
        this.brandName = result.data.name
        this.brandLogo = result.data.logo
      } catch(err) {
        //console.log(err)
      }
      this.$store.commit('SET_LOADING_STATUS', false);
      this.loading = false
    },
    async getArtist() {
      this.$store.commit('SET_LOADING_STATUS', true);
      this.loading = true
      try {
        let result = await axios.get('artistview' + '?id=' + this.artist_id);
        this.artistName = result.data.name
      } catch(err) {
        //console.log(err)
      }
      this.$store.commit('SET_LOADING_STATUS', false);
      this.loading = false
    },
    validateBudget() {
      this.budget = this.validateRate(this.budget)
    },
    validateRate(rate) {
      let amt = parseFloat(rate)
      if(isNaN(amt)) {
        amt = 0
      }
      return amt.toFixed(2) // round to nearest two decimal places and convert to string
    },
    async validateEmail() {
      if(this.email == '') {
        this.$store.commit('SET_EMAIL_INVALID_MSG', null)
        return
      }
      await this.$store.dispatch('validateEmail', {'email': this.email})
      if(this.emailInvalidMsg) {
        this.emailErrors = this.emailInvalidMsg
      } else {
        this.emailErrors = []
      }
    },
    // async validateZipcode() {
    //   if(this.zipcode == '') {
    //     return
    //   }
    //   await this.$store.dispatch('validateZipcode', {'zipcode': this.zipcode})
    //   if(this.$store.state.zipcode) {
    //     this.city = this.$store.state.zipcode.city
    //     this.state = this.$store.state.zipcode.state
    //     this.zipcodeErrors = []
    //   } else {
    //     this.zipcodeErrors = 'ZIP not found'
    //   }
    // },
    async addConsult() {
      this.loading = true
      await this.validateEmail()
      // await this.validateZipcode()
      // if(this.emailErrors.length || this.zipcodeErrors.length || !this.$refs.consultForm.validate()) {
      if(this.emailErrors.length || !this.$refs.consultForm.validate()) {
        this.loading = false
        this.consultDlg = false
        return
      }
      this.iFrameScrollToTop()
      let consult = {
        agent_id: this.agent_id,
        artist_id: this.artist_id,
        first: this.first,
        last: this.last,
        email: this.email,
        // city: this.city,
        // state: this.state,
        // zipcode: this.zipcode,
        cell_phone: this.cell,
        event_type: this.eventType,
        brand_id: this.brand_id,
        description: this.description,
        start: this.start,
        end: this.end,
        budget: this.budget
      }
      // if(this.prepaid) {
      //   data.prepaid = true
      // }
      try {
        await axios.post("consults", consult);
        this.$emit('success', "Request sent. Thanks! We'll be in touch soon.")
        this.done = true
        this.iFrameScrollToTop();
      } catch(err) {
        //console.log(err)
        this.$emit('error', "There was a problem sending the request.")
      }
      this.loading = false
      this.consultDlg = false
    }
  }
}
</script>

<style scoped>
.b-link {
  font-weight: bold;
  text-decoration: none;
}
.the-form {
  background-color: white !important;
}
</style>
